var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 32,
    viewBox: "0 0 38 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.375C4.8424 0.375 3.25268 1.03348 2.08058 2.20558C0.90848 3.37768 0.25 4.9674 0.25 6.625V7.25313L19 17.35L37.75 7.25625V6.625C37.75 4.9674 37.0915 3.37768 35.9194 2.20558C34.7473 1.03348 33.1576 0.375 31.5 0.375H6.5ZM37.75 10.8031L19.7406 20.5C19.513 20.6225 19.2585 20.6867 19 20.6867C18.7415 20.6867 18.487 20.6225 18.2594 20.5L0.25 10.8031V25.375C0.25 27.0326 0.90848 28.6223 2.08058 29.7944C3.25268 30.9665 4.8424 31.625 6.5 31.625H31.5C33.1576 31.625 34.7473 30.9665 35.9194 29.7944C37.0915 28.6223 37.75 27.0326 37.75 25.375V10.8031Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.7e1a6849c2e78937c5f416f0a49dbbfb.svg";
export { ForwardRef as ReactComponent };